import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter, HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <HashRouter> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* </HashRouter> */}
      <ToastContainer
        hideProgressBar={false}
        autoClose={false}
        newestOnTop={true}
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        closeOnClick={false}
        theme="dark"
      />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
